import React, { useEffect } from 'react'
import { cx } from 'class-variance-authority'
import { Copyright, FooterNavigation, Newsletter } from './footer/index'

interface FooterProps {
  isHidden?: boolean
  careerSite?: boolean
  colorCareerSite?: string
}

export const Footer = ({
  isHidden = false,
  careerSite = false,
  colorCareerSite = undefined,
}: FooterProps) => {
  useEffect(() => {
    const userLang = navigator.language
    const axeptioScript = document.createElement('script')
    const crispScript = document.createElement('script')
    const headEl = document.getElementsByTagName('head')[0]
    const body = document.getElementsByTagName('body')[0]

    const exludedCountry = [/en-US/i, /en-CA/i]

    if (
      !exludedCountry.some((reg) => reg.test(userLang)) &&
      process.env.NODE_ENV === 'production' &&
      !careerSite
    ) {
      if (body) {
        if (!window.axeptioSettings || !window.axeptioSettings.clientId) {
          axeptioScript.async = true
          axeptioScript.id = 'axeptio-script'
          axeptioScript.src = '//static.axept.io/sdk-slim.js'
          body?.appendChild(axeptioScript)

          window.axeptioSettings = {
            clientId: '65952763f645e43eed49bc7e',
            cookiesVersion: 'lamacompta-fr-EU',
          }
        }
      }

      if (headEl) {
        crispScript.type = 'text/javascript'
        crispScript.id = 'crisp-script'
        crispScript.innerHTML = `
              window.$crisp=[];
              window.CRISP_WEBSITE_ID="78e52ef7-df9c-4704-89ed-31d495a5c07b";
              (function(){
                  var d=document;
                  var s=d.createElement("script");
                  s.src="https://client.crisp.chat/l.js";
                  s.async=1;
                  d.getElementsByTagName("head")[0].appendChild(s);
              })();
          `
        headEl?.appendChild(crispScript)
      }
    }

    return () => {
      const existingCrispScript = document.getElementById('crisp-script')

      if (existingCrispScript) {
        existingCrispScript.remove()
      }

      const axeptioScriptElement = document.getElementById('axeptio-script')
      if (axeptioScriptElement) {
        axeptioScriptElement?.remove()
      }
    }
  }, [])

  return (
    <footer
      className={cx(
        'px-4 pt-8 pb-8 border-t md:border-t-0 border-night',
        isHidden ? 'sr-only' : 'block',
        careerSite ? 'bg-opacity-10' : 'md:pt-20 bg-very-light-blue',
      )}
      style={{
        backgroundColor: careerSite ? `${colorCareerSite}20` : undefined,
      }}
    >
      {careerSite ? (
        <div className="flex items-center justify-center">
          <p
            className="text-sm font-thin text-night"
            style={{ color: colorCareerSite }}
          >
            Hébergé par <a href="https://lamacompta.co/">Lamacompta</a>
          </p>
        </div>
      ) : (
        <div className="container mx-auto space-y-4 md:space-y-12 lg:space-y-18">
          <Newsletter />
          <FooterNavigation />
          <Copyright
            careerSiteColor={colorCareerSite}
            careerSite={careerSite}
          />
        </div>
      )}
    </footer>
  )
}
